import {
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
} from '@backstage/catalog-model';
import {
  EntityCardBlueprint,
  EntityRelationCard,
  entityColumnPresets,
} from '@backstage/plugin-catalog-react/alpha';

export const dependsOnComponentsCardOverride = EntityCardBlueprint.make({
  name: 'depends-on-components',
  params: {
    filter: { kind: 'component' },
    loader: async () => (
      <EntityRelationCard
        title="Depends on components"
        entityKind="Component"
        relationType={RELATION_DEPENDS_ON}
        columnConfig={entityColumnPresets.component.columns}
        emptyState={{
          message: 'No component is a dependency of this component.',
        }}
      />
    ),
  },
});

export const dependsOnResourcesCardOverride = EntityCardBlueprint.make({
  name: 'depends-on-resources',
  params: {
    filter: { kind: 'component' },
    loader: async () => (
      <EntityRelationCard
        title="Depends on resources"
        entityKind="Resource"
        relationType={RELATION_DEPENDS_ON}
        columnConfig={entityColumnPresets.resource.columns}
        emptyState={{
          message: 'No resource is a dependency of this component.',
        }}
      />
    ),
  },
});

export const hasSubcomponentsCardOverride = EntityCardBlueprint.make({
  name: 'has-subcomponents',
  params: {
    filter: { kind: 'component' },
    loader: async () => (
      <EntityRelationCard
        title="Has subcomponents"
        entityKind="Component"
        relationType={RELATION_HAS_PART}
        columnConfig={entityColumnPresets.component.columns}
        emptyState={{ message: 'No subcomponent is part of this component.' }}
      />
    ),
  },
});

export const hasSubdomainsCardOverride = EntityCardBlueprint.make({
  name: 'has-subdomains',
  params: {
    filter: { kind: 'domain' },
    loader: async () => (
      <EntityRelationCard
        title="Has subdomains"
        entityKind="Domain"
        relationType={RELATION_HAS_PART}
        columnConfig={entityColumnPresets.domain.columns}
        emptyState={{ message: 'No subdomain is part of this domain.' }}
      />
    ),
  },
});

export const hasResourcesCardOverride = EntityCardBlueprint.make({
  name: 'has-resources',
  params: {
    filter: { kind: 'system' },
    loader: async () => (
      <EntityRelationCard
        title="Has resources"
        entityKind="Resource"
        relationType={RELATION_HAS_PART}
        columnConfig={entityColumnPresets.resource.columns}
        emptyState={{ message: 'No resource is part of this system.' }}
      />
    ),
  },
});

export const hasSystemsCardOverride = EntityCardBlueprint.make({
  name: 'has-systems',
  params: {
    filter: { kind: 'domain' },
    loader: async () => (
      <EntityRelationCard
        title="Has systems"
        entityKind="System"
        relationType={RELATION_HAS_PART}
        columnConfig={entityColumnPresets.system.columns}
        emptyState={{ message: 'No system is part of this domain.' }}
      />
    ),
  },
});
